import React, { useState } from "react";
import axios from "axios";
import "../styles/CreateInvoice.css"; // Reuse existing styles or create a new CSS file

const AddItem = () => {
  const [formData, setFormData] = useState({
    itemCode: "",
    itemGroup: "",
    defaultUnitOfMeasure: "Nos", 
    itemName: "",
    hsN_SAC: "",
    maintainStock: 1, 
    valuationMethod: "FIFO", 
    defaultSalesUnit: "Nos", 
    defaultPurchaseUnit: "Nos", 
    company: "esoft technologies Private Limited (Demo)", 
    defaultWarehouse: "C-450 - ETPLD", 
    supplier: "", 
    valuationRate: "", 
    openingStock: "", 
  });

  const [status, setStatus] = useState({ message: "", type: "" }); // For success/error messages

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setStatus({ message: "Adding item...", type: "info" });

      const response = await axios.post(
        "https://erpnext.api.esoftech.com/api/ExcelImport/InsertItemDetails",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        setStatus({
          message: "Item added successfully!",
          type: "success",
        });
        // Clear the form after successful submission
        setFormData({
          itemCode: "",
          itemGroup: "",
          defaultUnitOfMeasure: "Nos",
          itemName: "",
          hsN_SAC: "",
          maintainStock: 1,
          valuationMethod: "FIFO",
          defaultSalesUnit: "Nos",
          defaultPurchaseUnit: "Nos",
          company: "esoft technologies Private Limited (Demo)",
          defaultWarehouse: "C-450 - ETPLD",
          supplier: "",
          valuationRate: "",
          openingStock: "",
        });
      } else {
        setStatus({
          message: "Failed to add item. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error adding item:", error);
      setStatus({
        message: "An error occurred while adding the item. Please check the details.",
        type: "error",
      });
    }
  };

  const handleCreateItems = async () => {
    try {
      setStatus({ message: "Creating items...", type: "info" });

      const response = await axios.post(
        "https://erpnext.api.esoftech.com/api/InvoiceOrder/CreateItems"
      );

      if (response.status === 200) {
        setStatus({
          message: "Items created successfully!",
          type: "success",
        });
      } else {
        setStatus({
          message: "Failed to create items. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      console.error("Error creating items:", error);
      setStatus({
        message: "An error occurred while creating items. Please check the details.",
        type: "error",
      });
    }
  };

  return (
    <div className="container">
      <h1 className="title">Add New Item to ERP</h1>
      <form onSubmit={handleSubmit} className="upload-section">
        {/* Item Code */}
        <div className="form-group">
          <label>Item Code</label>
          <input
            type="text"
            name="itemCode"
            value={formData.itemCode}
            onChange={handleChange}
            placeholder="100001"
            required
          />
        </div>

        {/* Item Group */}
        <div className="form-group">
          <label>Item Group</label>
          <input
            type="text"
            name="itemGroup"
            value={formData.itemGroup}
            onChange={handleChange}
            placeholder="Products/Health Care"
            required
          />
        </div>

        {/* Item Name */}
        <div className="form-group">
          <label>Item Name</label>
          <input
            type="text"
            name="itemName"
            value={formData.itemName}
            onChange={handleChange}
            placeholder="e.g. Smartphone"
            required
          />
        </div>

        {/* HSN/SAC */}
        <div className="form-group">
          <label>HSN/SAC</label>
          <input
            type="text"
            name="hsN_SAC"
            value={formData.hsN_SAC}
            onChange={handleChange}
            placeholder="34011190"
            required
          />
        </div>

        {/* Supplier */}
        <div className="form-group">
          <label>Supplier</label>
          <input
            type="text"
            name="supplier"
            value={formData.supplier}
            onChange={handleChange}
            placeholder="Crawford Market"
            required
          />
        </div>

        <div className="form-group">
          <label>valuationRate</label>
          <input
            type="text"
            name="valuationRate"
            value={formData.valuationRate}
            onChange={handleChange}
            placeholder="100"
            required
          />
        </div>

        <div className="form-group">
          <label>Quantity</label>
          <input
            type="text"
            name="openingStock"
            value={formData.openingStock}
            onChange={handleChange}
            placeholder="100"
            required
          />
        </div>

        {/* Submit Button */}
        <button type="submit" className="action-button">
          Add Item in Database
        </button>
        <br />

        {/* Create Items Button */}
        <button
          type="button"
          onClick={handleCreateItems}
          className="action-button"
          style={{ marginTop: "10px" }}
        > 
          Create Item in ERP
        </button>

        {/* Status Message */}
        {status.message && (
          <p className={`status ${status.type}`}>{status.message}</p>
        )}
      </form>
    </div>
  );
};

export default AddItem;